import React from "react";
import { styleBlock } from "../styleBlock";
export default (props) => {
    const { big, small } = props;
    const classNames = styleBlock("loader");
    return React.createElement("div", { className: classNames({ small, big }) });
};
//# sourceMappingURL=index.js.map